import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';
import { CheckboxFilterGroup } from '../../generic/Filter';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import type { Depth, AnyFilter } from '../../../../shared/organizationPackages';

const DEPTH_OPTIONS = [
  { key: 'direct', label: 'Direct' },
  { key: 'transitive', label: 'Transitive' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersPackageDepth displays two checkboxes which can be used to
 */
const PackageInventoryFiltersPackageDepth: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const depths = useSelector(PackageInventoryStore.selectors.getDepthFilters);
  //  Returns an onChange handler for our inputs
  const onSelect = (depth: Depth, isChecked: boolean) => {
    if (isChecked) {
      setFilters({ depth: [...depths, depth] });
    } else {
      setFilters({ depth: depths.filter(d => d !== depth) });
    }
  };
  return (
    <CheckboxFilterGroup
      title="Dependency depth"
      options={DEPTH_OPTIONS}
      selectedOptions={depths}
      onSelect={onSelect as (key: string, isChecked: boolean) => void}
      testId="package-inventory-filters--depth"
    />
  );
};

export default PackageInventoryFiltersPackageDepth;
